import { gql } from '@apollo/client';
import unavailablePeriodFragment from '../unavailablePeriodFragment';

const GET_ORG_UNIT_UNAVAILABLE_PERIODS = gql`
  query GetOrgUnitUnavailablePeriods {
    orgUnitUnavailablePeriods {
      ...UnavailablePeriodFields
    }
  }
  ${unavailablePeriodFragment}
`;

export default GET_ORG_UNIT_UNAVAILABLE_PERIODS;
